module.exports = __webpack_public_path__ + "static/media/talent-feature-interview-reschedule@2x.c41cdf24.png";